// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__yg-3c","emails":"CreateEditClinics_emails__105RH","emailTagLabel":"CreateEditClinics_emailTagLabel__3D39x"};